module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_3-565e5ed5f51afd4f158c2db5d933d31f.jpg";